import { render, staticRenderFns } from "./StudentListItem.vue?vue&type=template&id=6216b04e&scoped=true&lang=pug"
import script from "./StudentListItem.vue?vue&type=script&lang=js"
export * from "./StudentListItem.vue?vue&type=script&lang=js"
import style0 from "./StudentListItem.vue?vue&type=style&index=0&id=6216b04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216b04e",
  null
  
)

export default component.exports